export default __webpack_public_path__ + "static/exp-app-0378c5f3c89854507d57eda1f19a3f78.png";